/**
 * Created by stonewang on 2018/01/9.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  EditorState,
  convertToRaw,
  ContentState,
  RichUtils,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { config } from 'Utils';

class RichTextEditor extends Component {
  constructor (props) {
    super(props);
    let eState = null;
    if (this.props.htmlContent) {
      const blocksFromHtml = htmlToDraft(this.props.htmlContent);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      eState = EditorState.createWithContent(contentState);
    } else {
      eState = EditorState.createEmpty();
    }
    this.state = {
      editorState: eState,
      result: this.props.htmlContent || '',
      responseList: []
    };
    //文本编辑器
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.uploadImageCallBack = this.uploadImageCallBack.bind(this);
    this.handleKeyCommand = this.handleKeyCommand.bind(this);
    this.outputResult = this.outputResult.bind(this);
    this.onBlurHandle = this.onBlurHandle.bind(this);
  }

  componentWillReceiveProps (newProps) {
    if (newProps.htmlContent !== this.state.result) {
      let eState = null;
      if (newProps.htmlContent) {
        const blocksFromHtml = htmlToDraft(newProps.htmlContent);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        eState = EditorState.createWithContent(contentState);
      } else {
        eState = EditorState.createEmpty();
      }
      this.setState({
        editorState: eState,
        result: newProps.htmlContent,
      });
    }
  }

  onEditorStateChange (editorState) {
    const result = !editorState.getCurrentContent().getPlainText() ? '' : draftToHtml(convertToRaw(editorState.getCurrentContent()));
    this.setState({
      editorState,
      result
    }, () => {
      if (this.props.onChange) {
        this.props.onChange(result);
      }
    });
  }

  handleKeyCommand (command) {
    const { editorState } = this.state;
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onEditorStateChange(newState);
      return true;
    }
    return false;
  }

  uploadImageCallBack (file) {
    return new Promise(
      (resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`);
        const data = new FormData();
        data.append('image', file);
        xhr.send(data);
        xhr.addEventListener('load', () => {
          const response = JSON.parse(xhr.responseText);
          resolve({ data: { link: config.server + response.data.filePath, alt: '用户上传的图片' } });
        });
        xhr.addEventListener('error', () => {
          const error = JSON.parse(xhr.responseText);
          reject(error);
        });
      }
    );
  }

  outputResult () {
    return this.state.result;
  }

  onBlurHandle (e) {
    const { editorState } = this.state;
    const result = !editorState.getCurrentContent().getPlainText() ? '' : draftToHtml(convertToRaw(editorState.getCurrentContent()));
    if(this.props.onBlur) {
      this.props.onBlur(result);
    }
  }

  render () {
    const { editorState } = this.state;
    return (
      <div className="RichEditor-root editorHidden">
        <Editor
          readOnly={this.props.disabled}
          toolbarClassName={`RichTextEditor-toolbar${this.props.disabled ? ' disable' : ''}`}
          wrapperClassName="RichTextEditor-wrapper"
          editorClassName={`RichTextEditor-editor${this.props.disabled ? ' RichTextEditor-disabled' : ''}`}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          handleKeyCommand={this.handleKeyCommand}
          onBlur={this.onBlurHandle}
          toolbar={{
            image: {
              uploadCallback: this.uploadImageCallBack,
            },
          }}
          localization={{
            locale: 'zh',
          }}
        />
      </div>
    );
  }
}
RichTextEditor.propTypes = {
  htmlContent: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
RichTextEditor.defaultProps = { // as static property
  disabled: false,
};
export default RichTextEditor



// WEBPACK FOOTER //
// ./src/components/richTextEditor.js